import { useApi, useApiMutation, useTempData } from '@/lib/hook';
import style from './style.module.scss'
import { AddButton, Button, Filter, OptionButton, PageTitle } from '@/theme';
import { Flex, Spin, Table } from 'antd';
import cn from 'classnames';
import { paginationHelper } from '@/lib/utils';
import { useState } from 'react';
import { VideoDetailsModal } from './modals/videoDetailsModal';
import { DeleteOutlined, EyeOutlined } from '@ant-design/icons';


const initFilterData = {
    page: 1,
}

export const HowToVideosComponent = () => {
    const { data: tempData, setTempData } = useTempData('how_to_videos_page', initFilterData);
    const [openModal, setOpenModal] = useState(null)

    const { data, isFetching, refetch } = useApi({
        route: { name: 'howToVideos.list' },
        data: {
            page: tempData.page,
            filter: tempData.filter
        }
    })

    const onChangeFilter = (value) => {
        setTempData({
            page: 1,
            filter: {
                ...tempData.filter,
                ...value,
            }
        })
    }

    const update = useApiMutation({
        onSuccess: () => {
            refetch()
        }
    })

    const onDeleteVideo = (id) => {
        update.mutate({
            route: { name: 'howToVideos.delete', query: { id } }
        })
    }
    
    const columns = [
        {
            title: 'Title',
            render: (item) => (
                <>
                    <div className={style.title}>
                        {item.name}
                    </div>
                </>
            )
        },
        {
            title: 'Links',
            render: (item) => (
                <>
                    <div className={style.title}>
                        {item.link}
                    </div>
                </>
            )
        },
        {
            title: 'Actions', width: '112px', className: 'tl_center',
            render: (item) => (
                <div
                    className={style.actions_cell}
                >
                    {/* <Button
                        icon={<EyeOutlined />}
                        type={'text'}
                        onClick={() => {
                            showNews(item)
                        }}
                    /> */}
                    <OptionButton>
                        <OptionButton.Button
                            onClick={() => {
                                openModalHandler(item)
                            }}
                        >
                            Edit
                        </OptionButton.Button>
                        <OptionButton.Button
                            onClick={() => {
                                onDeleteVideo(item.id)
                            }}
                            confirm={{
                                title: `Are you sure you want to delete link ?`,
                                content: 'If you delete a link, all data will be irretrievably lost',
                                type: 'delete',
                                okButtonProps: {
                                    type: 'primary',
                                    icon: <DeleteOutlined />,
                                }
                            }}
                            type={'danger'}
                        >
                            Delete
                        </OptionButton.Button>
                    </OptionButton>
                </div>
            )
        },
    ]

    const onChangePage = (page) => {
        setTempData({
            page,
            filter: {
                ...tempData.filter
            }
        })
    }

    const cancelModal = () => {
        setOpenModal(null)
    }

    const openModalHandler = (value) => {
        setOpenModal(value)
    }

    return (
        <>
            <PageTitle
                title={'How-To Videos'}
                extra={(
                    <AddButton onClick={() => openModalHandler('create')}>Add new link</AddButton>
                )}
            />

            <Spin spinning={isFetching}>
                {/* <VideosFilter
                    initialValues={tempData}
                    onChangeFilter={onChangeFilter}
                /> */}

                <Table
                    className={style.table}
                    style={{
                        marginTop: 16,
                    }}
                    dataSource={data?.data}
                    columns={columns}
                    rowKey={'id'}
                    pagination={data?.meta ? paginationHelper(data.meta, onChangePage) : false}
                />
            </Spin>
            <VideoDetailsModal
                data={openModal}
                cancelModal={cancelModal}
                refetch={refetch}
            />
        </>
    )
}

const VideosFilter = ({ initialValues, onChangeFilter }) => {
    return (
        <Filter
            initialValues={initialValues}
            onChange={onChangeFilter}
            useFilters={[
                {
                    type: 'search',
                    name: 'q',
                    placeholder: 'Search by title...',
                    width: 368,
                }
            ]}
            wrapper={(children, level) => (
                <div className={cn(style.filter, { [style.main_level]: level === 1 })}>
                    {children}
                </div>
            )}
        />
    )
}